"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketClient = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const socket_io_client_1 = require("socket.io-client");
class WebsocketClient {
    constructor(url, loginUrl, query) {
        this.loginUrl = loginUrl;
        const token = window.localStorage.getItem('uxa:jwt');
        this.socket = (0, socket_io_client_1.io)(url, {
            query,
            transports: ['websocket'],
            auth: {
                token,
            },
            withCredentials: true,
        });
        this.streamJwtExceptions().subscribe({
            next: () => this.redirectToLoginOnJwtError(),
        });
    }
    streamListenerId() {
        return new rxjs_1.Observable((observer) => {
            this.onConnection(() => observer.next(this.socket.id));
        });
    }
    stream(event) {
        return new rxjs_1.Observable((observer) => {
            this.on(event, (data) => {
                observer.next(data);
            });
        });
    }
    close() {
        this.socket.close();
    }
    emit(event, ...args) {
        this.socket.emit(event, ...args);
    }
    on(event, listener) {
        this.socket.on(event, listener);
    }
    onConnection(listener) {
        this.on('connect', listener);
    }
    streamExceptions() {
        return this.stream('exception');
    }
    streamJwtExceptions() {
        return this.streamExceptions().pipe((0, operators_1.filter)((error) => error.status.indexOf('JWT_') === 0));
    }
    redirectToLoginOnJwtError() {
        const url = new URL(this.loginUrl);
        url.searchParams.append('redir', location.href);
        window.location.assign(url.href);
    }
}
exports.WebsocketClient = WebsocketClient;
//# sourceMappingURL=websocket.client.js.map